/**
 * Menu Service - API calls for menu configuration
 * Created: 1405/02/17
 */

import api from '../../services/api';
import { MenuItem, MenuConfiguration } from '../types';

const BASE_URL = '/menu';

export interface SaveMenuConfigurationRequest {
  items: MenuItem[];
  isActive: boolean;
}

export interface MenuValidationResponse {
  isValid: boolean;
  errors: Array<{
    field: string;
    message: string;
    itemId?: string;
  }>;
}

const menuService = {
  /**
   * Get active menu configuration
   */
  getActiveConfiguration: async (): Promise<MenuConfiguration | null> => {
    try {
      const response = await api.get(`${BASE_URL}/active`);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  /**
   * Get menu configuration by ID
   */
  getConfigurationById: async (id: number): Promise<MenuConfiguration> => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Get menu configuration history
   */
  getHistory: async (): Promise<MenuConfiguration[]> => {
    const response = await api.get(`${BASE_URL}/history`);
    return response.data;
  },

  /**
   * Save new menu configuration
   */
  saveConfiguration: async (request: SaveMenuConfigurationRequest): Promise<MenuConfiguration> => {
    const response = await api.post(BASE_URL, request);
    return response.data;
  },

  /**
   * Update existing configuration
   */
  updateConfiguration: async (
    id: number, 
    request: SaveMenuConfigurationRequest
  ): Promise<void> => {
    await api.put(`${BASE_URL}/${id}`, request);
  },

  /**
   * Set configuration active status
   */
  setActiveStatus: async (id: number, isActive: boolean): Promise<void> => {
    await api.patch(`${BASE_URL}/${id}/status`, isActive);
  },

  /**
   * Validate menu items
   */
  validateMenu: async (items: MenuItem[]): Promise<MenuValidationResponse> => {
    const response = await api.post(`${BASE_URL}/validate`, items);
    return response.data;
  },
};

export default menuService;
